// src/components/divider/divider.custom.styles.ts
import { css } from "lit";
var divider_custom_styles_default = css`
  /* Write custom CSS here */
  :host {
    --color: var(--syn-color-neutral-400);
  }
`;
export { divider_custom_styles_default };
